// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2wfPI","validationTips":"StatementDescriptor_validationTips__oKgyf"};